import { useTranslation } from 'react-i18next'
import { capitalize, map } from 'lodash'
import moment from 'moment'

const omr = value => `OMR ${Number(value || 0).toFixed(3)}`
const fmtDate = value => (value ? moment(value).format('DD MMM YYYY, HH:mm') : '')

const ENTRY_BADGE = {
  paymob: 'bg-blue-50 text-blue-700 ring-blue-200',
  thawani: 'bg-amber-50 text-amber-700 ring-amber-200',
  wallet: 'bg-violet-50 text-violet-700 ring-violet-200',
  unknown: 'bg-slate-100 text-slate-600 ring-slate-200',
}

/** Refund entries for one booking, with paid / refunded / remaining in the header (admin only). */
const BookingRefunds = ({ summary }) => {
  const { t } = useTranslation()
  if (!summary || !(summary.paidTotal > 0)) return null

  if (!summary.entries?.length) return null

  return (
    <section className="w-full rounded-2xl border border-slate-200/80 bg-white px-4 py-3 sm:px-5 shadow-[0_1px_3px_rgba(15,23,42,0.05)]">
      <div className="mb-1 flex flex-wrap items-center justify-between gap-2">
        <span className="text-[11px] font-bold uppercase tracking-wider text-slate-700">{t('booking.refunds.entries')}</span>
        <span className="text-xs text-slate-500 tabular-nums">
          {t('booking.refunds.paid')} {omr(summary.paidTotal)} · {t('booking.refunds.refunded')} <span className="font-semibold text-emerald-700">{omr(summary.refunded)}</span> ·{' '}
          {t('booking.refunds.remaining')} <span className="font-semibold text-rose-700">{omr(summary.remaining)}</span>
        </span>
      </div>
      <ul className="divide-y divide-slate-100">
        {map(summary.entries, (entry, i) => (
          <li key={i} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2">
            <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 text-sm">
              <span className={`inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${ENTRY_BADGE[entry.source] || ENTRY_BADGE.unknown}`}>
                {t(`booking.refunds.source.${entry.source}`)}
              </span>
              {entry.type && <span className="font-medium text-slate-800">{entry.source === 'wallet' ? entry.type : capitalize(entry.type)}</span>}
              {entry.reference && (
                <span className="text-xs text-slate-500">
                  {entry.source === 'paymob' ? 'Txn' : 'RRN'}: {entry.reference}
                </span>
              )}
              {entry.at && <span className="text-xs text-slate-400">{fmtDate(entry.at)}</span>}
            </div>
            <span className={`text-sm font-semibold tabular-nums ${entry.amount < 0 ? 'text-rose-700' : 'text-emerald-700'}`}>
              {entry.amount < 0 ? '−' : '+'} {omr(Math.abs(entry.amount))}
            </span>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default BookingRefunds
